import { calculateProjectedValue, MAXIMUM_TAX_FREE_CASH } from '~/utils';

export const usePensionCalculations = (
    age: number,
    retirementAge: number,
    pensionAmount?: number,
    grossContributions?: number,
    purchasePrice?: number
) => {
    const projectedValue = calculateProjectedValue(
        age,
        retirementAge,
        Number(pensionAmount || 0),
        Number(grossContributions || 0)
    );
    const taxFreeCash = Math.min(Math.floor(projectedValue * 0.25), MAXIMUM_TAX_FREE_CASH);
    let remainingPot = projectedValue - taxFreeCash;

    if (purchasePrice) {
        remainingPot -= purchasePrice;
    }

    return {
        projectedValue,
        taxFreeCash,
        remainingPot,
    };
};
